import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FormTextField } from '@skupreme/shared/ui/form';
import OAuthService from '@utility/services/oauth';
import { ToastMessage } from '@utility/toast';
import { ConnectPopup } from './ConnectPopup';

type SellerCloudMetadataValues = { warehouseId: string };

type SellerCloudMetadataPopupProps = {
  open: boolean;
  onClose: () => void;
  marketplaceId: string;
  initialWarehouseId?: string;
  refetch?: () => void;
};

export default function SellerCloudMetadataPopup({
  open,
  onClose,
  marketplaceId,
  initialWarehouseId,
  refetch,
}: SellerCloudMetadataPopupProps) {
  const { control, handleSubmit, setValue } =
    useForm<SellerCloudMetadataValues>({
      mode: 'onChange',
      defaultValues: {
        warehouseId: initialWarehouseId || '',
      },
    });

  useEffect(() => {
    setValue('warehouseId', initialWarehouseId || '');
  }, [initialWarehouseId, setValue]);

  const submit = handleSubmit(async values => {
    try {
      const payload = {
        marketplaceId,
        warehouseId: String(values.warehouseId || '').trim(),
      };

      if (!payload.warehouseId) {
        ToastMessage.error('Warehouse ID is required.');
        return;
      }

      await OAuthService.configureMarketplaceMetadata(payload);

      ToastMessage.success('SellerCloud metadata saved.');
      if (typeof refetch === 'function') refetch();
      onClose();
    } catch (err) {
      ToastMessage.apiError(err);
    }
  });

  if (!open) return null;

  return (
    <ConnectPopup
      open={open}
      title="Configure SellerCloud Metadata"
      onClose={onClose}
      onSubmit={submit}
      submitLabel="Save"
      size="lg"
    >
      <FormTextField
        control={control}
        name="warehouseId"
        label="Warehouse ID"
        placeholder="Enter Warehouse ID"
        isRequired
      />
    </ConnectPopup>
  );
}
